const FAMILY = {
  metric: 'metric',
  metric_query: 'metric',
  metric_alerts: 'metric',
  metric_insights: 'metric',
  metric_worklist: 'metric',
  metric_worklist_columns: 'metric',
  metric_patients: 'metric',
  insight: 'insight',
  worklist: 'worklist',
  patient_flag: 'flag',
  data_attribute: 'attribute',
  workflow: 'workflow',
  workflow_sheet: 'workflow',
  entity_parents: 'entity',
  entity_levels: 'entity',
  hermes: 'hermes',
};

export const FAMILIES = [
  { key: 'metric', label: 'Metric', tone: 'bg-amber-100 text-amber-800' },
  { key: 'attribute', label: 'Data attribute', tone: 'bg-sky-100 text-sky-800' },
  { key: 'insight', label: 'Insight', tone: 'bg-violet-100 text-violet-800' },
  { key: 'worklist', label: 'Worklist', tone: 'bg-rose-100 text-rose-800' },
  { key: 'flag', label: 'Patient flag', tone: 'bg-pink-100 text-pink-800' },
  { key: 'workflow', label: 'Workflow', tone: 'bg-emerald-100 text-emerald-800' },
  { key: 'hermes', label: 'Hermes template', tone: 'bg-indigo-100 text-indigo-800' },
  { key: 'entity', label: 'Entity', tone: 'bg-gray-200 text-gray-700' },
];

export const GENERIC_KINDS = new Set(Object.keys(FAMILY).filter((k) => FAMILY[k] === 'metric' || FAMILY[k] === 'entity'));

export function kindFamily(kind) {
  return FAMILY[kind] || '';
}

export function kindTone(kind) {
  const family = FAMILIES.find((f) => f.key === kindFamily(kind));
  return family ? family.tone : 'bg-gray-100 text-gray-700';
}

export function kindLabel(kind) {
  const family = FAMILIES.find((f) => f.key === kindFamily(kind));
  return family ? family.label.toLowerCase() : String(kind || '').replace(/_/g, ' ');
}
